import { api, downloadFile } from '@config/api';
import type { ColumnsExportOptions, PaginatedListResponse } from '@features/allocation';
import type {
  ManagerKind,
  ManagerOption,
  ProjectFilters,
  ProjectRow,
  ProjectsResponse,
  ProjectUpdateBody,
} from '../types/ProjectList';

/** Listas vão como `0,4`, não como parâmetro repetido. */
const toParams = ({ statusIds, ...filters }: Partial<ProjectFilters>) => ({
  ...filters,
  statusIds: statusIds?.join(','),
});

export const projectListService = {
  list: (filters: ProjectFilters, signal?: AbortSignal) =>
    api
      .get<ProjectsResponse>('/projects/management', { params: toParams(filters), signal })
      .then((r) => r.data),

  /** `slice` limita o arquivo a uma página; sem ele, vão todas. */
  exportSpreadsheet: (
    filters: Omit<ProjectFilters, 'page' | 'perPage'>,
    { format, columns, language }: ColumnsExportOptions,
    slice?: { page: number; perPage: number },
  ) =>
    downloadFile('/projects/management/export', {
      ...toParams(filters),
      ...slice,
      format,
      columns: columns.join(','),
      language,
    }),

  /** Edição por admin: só os 5 campos liberados. Devolve o projeto atualizado. */
  update: (id: number, body: ProjectUpdateBody) =>
    api.patch<ProjectRow>(`/projects/management/${id}`, body).then((r) => r.data),

  /** Lookup de gestores ativos de um tipo, para os combos da edição. */
  listManagers: (kind: ManagerKind, search: string, signal?: AbortSignal) =>
    api
      .get<PaginatedListResponse<ManagerOption>>('/managers', {
        params: { kind, search: search || undefined },
        signal,
      })
      .then((r) => r.data),
};
